import { render, staticRenderFns } from "./approach.vue?vue&type=template&id=8a7eb522&"
import script from "./approach.vue?vue&type=script&lang=js&"
export * from "./approach.vue?vue&type=script&lang=js&"
import style0 from "./approach.vue?vue&type=style&index=0&lang=scss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports